import { render, staticRenderFns } from "./mBuzzer.vue?vue&type=template&id=2ca43034&scoped=true"
import script from "./mBuzzer.vue?vue&type=script&lang=js"
export * from "./mBuzzer.vue?vue&type=script&lang=js"
import style0 from "./mBuzzer.vue?vue&type=style&index=0&id=2ca43034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca43034",
  null
  
)

export default component.exports